<script>
import api from "@/axios";
import Loader from "../components/loader";
import Layout from '../../layouts/main'
import PageHeader from '@/components/page-header'
// import MonitoraTable from './monitora-table'
import appConfig from "@/app.config";
import Swal from "sweetalert2"
import { Vue3Lottie } from 'vue3-lottie'
import 'vue3-lottie/dist/style.css'
import animationJson from '@/assets/animations/monitoramento_anim.json'

import {clientesChart1, clientesChart2 } from "../components/data-simulados";
import exportFromJSON from "export-from-json";
import moment from "moment/moment";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Monitoramento XML",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, Loader, Vue3Lottie }, //MonitoraTable,

  data() {
    return {
      animationJson,
      title: 'Relatórios Fiscais',
      items: [
        {
          text: 'Fiscais',
          href: '/',
        },
        {
          text: 'Relatórios',
          active: true,
        },
      ],
      loadingList: true,
      loadingGraph: true,
      monitorasList: null,
      updating: false,
      periodo: null,
      periodoPesq: false,
      cliChart1: clientesChart1,
      cliChart2: clientesChart2,
      pesqTextFilter: '',
      statusFilter: 'T',
      dtIniFiltro: null,
      dtFimFiltro: null,
    }
  },

  mounted() {
    console.log('mounted monitora-list_0')
    let dataAtu = new Date()
    const anoAtu = dataAtu.getFullYear()
    // const mesAtu = ("0" + (dataAtu.getMonth() + 1)).slice(-2)
    const mesAtu = ("0" + (dataAtu.getMonth())).slice(-2)
    // console.log(dataAtu.getFullYear())
    // console.log(dataAtu.getMonth())
    // console.log(mesAtu)
    // console.log(anoAtu)
    this.periodo = anoAtu + '-' + mesAtu
    this.atualizaDataList()
  },

  methods: {

    confirmarPeriodo(){
      console.log('confirmarPeriodo')

      localStorage.setItem('filtros', JSON.stringify({
        'movdi': moment(this.dtIniFiltro).format('YYYY-MM-DD'),
        'movdf': moment(this.dtFimFiltro).format('YYYY-MM-DD'),
      }))

      // this.showModalPeriodo = false
      this.atualizaDataList()
    },

    atualizaDataList(){

      const filtros = JSON.parse(localStorage.getItem("filtros"))

      if (!filtros) {
        console.log('cookie dataMov não existe, criando')
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
        localStorage.setItem('filtros', JSON.stringify({
          'movdi': perIniPadrao,
          'movdf': perFimPadrao,
        }))
      } else {
        this.dtIniFiltro = filtros['movdi']
        this.dtFimFiltro = filtros['movdf']
      }

      if (!this.dtIniFiltro && !this.dtFimFiltro) {
        console.log('sem filtro')
        let perIniPadrao = moment().add(-30, 'days').startOf('month').format('YYYY-MM-DD')
        // let perIniPadrao = moment().add(-1, 'days').format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date()).format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
      }

      this.loadingList = true
      api.get(`${getBaseUrl()}api/monitoras`, {
        params: {
          'q': this.pesqTextFilter,
          's': this.statusFilter,
          'di': this.dtIniFiltro,
          'df': this.dtFimFiltro
        }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data[0])
        // this.monitorasList = res.data[0]
        this.title = `Relatórios Fiscais` //(${this.monitorasList.length})
        this.loadingList = false


        /*const dtIniFormated = moment(this.dtIniFiltro)
            .format('DD/MM/YYYY')
        const dtFimFormated = moment(this.dtFimFiltro)
            .format('DD/MM/YYYY')

        this.title = `Relatórios de Orçamento: periodo(${dtIniFormated} - ${dtFimFormated})`*/

        // api.post(`${getBaseUrl()}api/postnfeconsch`,  {
        //   idData: 472
        // }).then((res) => {
        //   console.log('then axios')
        //   console.log(res)
        // })



      });
    },

    deletaReg(dataID) {
      console.log('deletaReg_pai dataID:')
      console.log(dataID)
      this.loadingList = true
      api.delete(`${getBaseUrl()}api/monitora`, {
        params: {
          'iddata': dataID
        }
      }).then((res) => {
        console.log('then axios delete')
        console.log(res.data)
        this.atualizaDataList()
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações excluídas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })
      })
    },

    relEFDFiscal(){
      console.log('relEFDFiscal')
      console.log(this.periodo)
      console.log(typeof this.periodo)
      this.updating = true
      api.get(`${getBaseUrl()}api/efdfisc`, {
        params: {
          periodo: this.periodo
        }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.empresaData = res.data[0]
        const data = res.data[1]
        const fileName = "EFD_Fiscal_" + this.empresaData.fantasia + '_' + this.periodo;
        const exportType = exportFromJSON.types.txt;
        if (data) exportFromJSON({ data, fileName, exportType });
        this.updating = false
      });
    },

    relEFDPisCofins(){
      console.log('relEFDPisCofins')
      console.log(this.periodo)
      console.log(typeof this.periodo)
      this.updating = true
      api.get(`${getBaseUrl()}api/efdpiscof`).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.empresaData = res.data[0]
        const data = res.data
        const fileName = "EFD_PisCofins_" + this.empresaData.fantasia + '_' + this.periodo;
        const exportType = exportFromJSON.types.txt;
        if (data) exportFromJSON({ data, fileName, exportType });
        this.updating = false
      });
    },

    relResultados(){
      console.log('relResultados')
      console.log(this.periodo)
      console.log(typeof this.periodo)
      this.updating = true

      api.get(`${getBaseUrl()}api/relresults`, {
        responseType: 'blob'
      }).then((res) => {
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'Relatorio_resultados_001.pdf');
        document.body.appendChild(fileLink);
        fileLink.click();
        this.updating = false
      })

    },

    confirmaPesq() {
      console.log('titleTime')

      /*const dtIniFormated = moment(this.dtIniFiltro).format('DD/MM/YYYY')
      const dtFimFormated = moment(this.dtFimFiltro).format('DD/MM/YYYY')

      this.title = `Relatórios de Orçamento: ${dtIniFormated} - ${dtFimFormated}`*/
    },


    mudouPeriodo(){
      console.log('mudouPeriodo')
      console.log(this.periodo)
      console.log(typeof this.periodo)
      // this.carregarDados()
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },


  },


}
</script>

<template>
  <Layout>


    <span class="float-end" style="z-index: 1000; position: absolute; top: 10px; right: 180px;">
      <Vue3Lottie :animationData="animationJson" :height="250" :width="250" />
    </span>

    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <!--<div class="row mb-2">
              &lt;!&ndash;<div class="col-sm-2">
                  <div class="search-box me-2 mb-2 d-inline-block">
                    <div class="position-relative">
                      <input
                          id="inputPesquisa"
                          type="text"
                          v-model="pesqTextFilter"
                          class="form-control"
                          placeholder="Enter para pesquisar..."
                          @change="atualizaDataList"/>
                      <i class="bx bx-search-alt search-icon"></i>
                    </div>
                  </div>
                </div>&ndash;&gt;
              &lt;!&ndash;<div class="col-sm-8">
                  <div class="text-sm-end">

                    <router-link :to="`/movcompra/importar/0`">
                      <button type="button" class="btn btn-success btn-rounded mb-2 me-2" >
                        <i class="mdi mdi-plus me-1"></i> Novo Arquivo
                      </button>
                    </router-link>

                  </div>
                </div>&ndash;&gt;
            </div>-->

            <div class="row mt-4" v-if="!updating">

              <div class="col-sm-1">
                <span class="avatar-title rounded-circle bg-soft bg-warning text-warning font-size-22" >
                  <i class="mdi mdi-filter"></i>
                </span>
              </div>

              <div class="col-sm-2">
                <div class="col-sm-12 text-muted">
                  <h5>Selecione o Período do Relatório</h5>
                </div>

                <div class="col-sm-12 mx-2 mt-4" style="width: 150px">
                  <label for="periodoPesq"> Tipo do Filtro </label>
                  <div class="d-flex align-items-center justify-content-between" style="margin-top: -12px">
                    <b-form-checkbox
                        id="periodoPesq"
                        switch
                        size="md"
                        v-model="periodoPesq">
                      {{ periodoPesq === true ? 'Filtrar Período' : 'Filtrar Mês' }}
                    </b-form-checkbox>
                  </div>
                </div>
              </div>

              <div class="row col-sm-4 text-start">

                <div v-if="periodoPesq === false" class="col-md-6">
                  <div class="mb-3">
                    <label for="periodo">Filtro Mensal</label>
                    <input
                        id="periodo"
                        v-model="periodo"
                        type="month"
                        @change="mudouPeriodo"
                        class="form-control"
                        style="max-width: 200px;"
                        placeholder="Início"/>
                  </div>
                </div>

                <div v-if="periodoPesq === false" class="col-md-6"></div>


                <div v-if="periodoPesq === true" class="col-md-6">
                  <div class="mb-3">
                    <label for="dtIniFiltro">Dt. Início</label>
                    <input
                        id="dtIniFiltro"
                        v-model="dtIniFiltro"
                        type="date"
                        class="form-control"
                        placeholder="Data Início"
                        :class="{'is-invalid': submittedPeriodo && !dtIniFiltro,}"/>
                    <div v-if="submittedPeriodo && !dtIniFiltro"
                         class="invalid-feedback">
                      <span>Campo data início obrigatório, favor preencher.</span>
                    </div>
                  </div>
                </div>

                <div v-if="periodoPesq === true" class="col-md-6">
                  <div class="mb-3">
                    <label for="dtFimFiltro">Dt. Final</label>
                    <input
                        id="dtFimFiltro"
                        v-model="dtFimFiltro"
                        type="date"
                        class="form-control"
                        placeholder="Data Final"
                        :class="{'is-invalid': submittedPeriodo && !dtFimFiltro,}"/>
                    <div v-if="submittedPeriodo && !dtFimFiltro"
                         class="invalid-feedback">
                      <span>Campo data final obrigatória, favor preencher.</span>
                    </div>
                  </div>
                </div>

                <div class="col-sm-6">
                  <div class="search-box me-2 mb-2 d-inline-block">
                    <div class="position-relative">
                      <select
                          id="selectStatus"
                          v-model="statusFilter"
                          @change="atualizaDataList"
                          class="form-control select2-search-disable">
                        <option value="T" selected>Todos</option>
                        <option value="A">Ativos</option>
                        <option value="I">Inativos</option>
                      </select>
                      <i class="bx bx-filter-alt search-icon"></i>
                    </div>
                  </div>
                </div>

              </div>

              <div class="row col-sm-3" style="margin-top: 30px; margin-left: 60px">
                <div class="col-sm-12 mx-4">
                  <b-button variant="primary"
                            style="padding: 5px 50px"
                            @click="confirmaPesq">
                    <i class="bx bx-search"></i>
                  </b-button>
                </div>

              </div>


              <div class="col-sm-1" style="margin-left: 100px">
                <b-dropdown
                    toggle-class=" font-size-12 mx-2"
                    variant="outline-primary"
                    right
                    class="ms-auto"
                    menu-class="dropdown-menu-end">

                  <template #button-content>
                    <i class="bx bx-file"></i> Export
                  </template>

                  <b-dropdown-item href="#" @click="confirmaPesq"> Relatório 1 </b-dropdown-item>
                  <b-dropdown-item href="#" @click="confirmaPesq"> Relatório 2 </b-dropdown-item>
                  <b-dropdown-item href="#" @click="confirmaPesq"> Relatório 3 </b-dropdown-item>
                </b-dropdown>
              </div>


            </div>

            <Loader v-if="loadingList" style="min-height: 300px;">
            </Loader>

            <!--            <MonitoraTable v-if="!loadingList"
                           :monitorasList="monitorasList"
                           @deletareg="deletaReg"/>

            <ul class="pagination pagination-rounded justify-content-end mb-2">
              <li class="page-item disabled">
                <a class="page-link" href="javascript: void(0);" aria-label="Previous">
                  <i class="mdi mdi-chevron-left"></i>
                </a>
              </li>
              <li class="page-item active">
                <a class="page-link" href="javascript: void(0);">1</a>
              </li>
              <li class="page-item disabled">
                <a class="page-link" href="javascript: void(0);" aria-label="Next">
                  <i class="mdi mdi-chevron-right"></i>
                </a>
              </li>
            </ul>-->
          </div>

        </div>
      </div>
    </div>

  </Layout>
</template>

